exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fabric-container .grid-title[data-v-7e5f1c20] {\n  border-top: 1px solid #eee !important;\n}\n.fabric-container .image[data-v-7e5f1c20] {\n  width: 100%;\n  height: 200px;\n}\n.fabric-container .text-capitalize[data-v-7e5f1c20] {\n  text-transform: uppercase;\n}\n.fabric-container h3[data-v-7e5f1c20] {\n  margin-top: 0px;\n  margin-bottom: 15px;\n}\n.fabric-container h4[data-v-7e5f1c20] {\n  margin-bottom: 0px;\n}\n.fabric-container .fabric-dropdown[data-v-7e5f1c20] {\n  position: absolute;\n  bottom: 30px;\n  right: 30px;\n}\n.fabric-card[data-v-7e5f1c20] {\n  max-height: 235px !important;\n  min-height: 235px;\n}\n", ""]);

// exports
